module.exports = {
        srcSet: __webpack_public_path__ + "static/media/scale-400.fb1ea86c.webp"+" 400w",
        images: [{path: __webpack_public_path__ + "static/media/scale-400.fb1ea86c.webp",width: 400,height: 400}],
        src: __webpack_public_path__ + "static/media/scale-400.fb1ea86c.webp",
        toString: function(){return __webpack_public_path__ + "static/media/scale-400.fb1ea86c.webp"},
        
        width: 400,
        height: 400
      }